import T from '../../services/language';
import {Container, ContainerView, ContainerViewFooter} from "../../components/Container";
import {Header} from "../../components/Header";
import Step from "../../components/Step";
import {NextButton, PackageButton, Packages} from "../../components/Button";
import {useEffect, useRef, useState} from "react";
import {
    Calendar,
    checkLimitDayBooking,
    checkOutSlot,
    ChooseTime,
    Control,
    ControlRow,
    InputView,
    LabelView,
    LabelView2,
    LabelViewSub,
    TextAreaView,
    TextView
} from "./style";
import {message} from "antd";
import {useApp} from "../../contexts/app";
import {useNavigate, useParams} from "react-router-dom";
import {CacheScheduleService, getLocalTimezone, getScheduleAvailable, listSchedule} from "../../services/app";
import moment from "moment";
import {formatSchedulesAsync, getCalenderMonthStartAndEnd} from "./service";
import useStateAsync from "use-state-async";
import Product from "./product";
import {PlaceholderLoadingContainer} from "../../components/Loading/placeholder";
import Environment from "../../environment";
import BookingLoading from "./loading";
import useSessionCompleted from "../../hooks/completed";
import AnonymousChatPopup from "../AnonymoysChat/popup";

export default function Booking() {
    const format = Environment.dateFormat;
    let {
        campaignPath,
        campaignId,
        customerId,
        productServiceId,
        productServiceType,
        quantity,
        packageIndex,
        postalCode, locationType, productServiceTemplateId
    }: any = useParams();
    const {
        setLoading,
        setCurrentBooking,
        getCurrentBooking,
        getAllBooking,
        getLocalProductService,
        getLocalAddress, clientCode,
        campaign
    } = useApp();
    const navigate = useNavigate();
    const placeholderLoadingRef = useRef<any>();

    const [schedules, setSchedules] = useState([]);
    let globalAddress = (getLocalAddress(customerId) || {});
    const globalBooking = (getCurrentBooking(packageIndex) || {});
    const bookingDateDefaultRef = useRef(moment().format(Environment.dateFormat));
    const [draft, setDraft, putDraft] = useStateAsync({
        bookingDate: bookingDateDefaultRef.current,
        customerId: customerId,
        ...globalAddress,
        campaignProductId: productServiceId,
        quantity: 1,
        campaignServiceId: productServiceId,
        campaignScheduleId: "",
        scheduleId: "",
        campaignId: campaignId,
        ...globalBooking
    });
    const date = draft?.bookingDate ? moment(draft?.bookingDate, format) : moment(Date.now());
    const resultCalenderMonthStartAndEn = getCalenderMonthStartAndEnd(date);
    const startMonth = resultCalenderMonthStartAndEn.startMonth.format(format);
    const endMonth = resultCalenderMonthStartAndEn.endMonth.format(format);
    const [firstLoad, setFirstLoad] = useState(false);
    const [devTz, setDevTz] = useState(localStorage.getItem("DEV_TZ"));
    const [delayLoading, setDelayLoading] = useState(true);
    packageIndex = parseInt(packageIndex);
    quantity = parseInt(quantity);
    const startLoadRef = useRef(0);
    const sessionCompleted = useSessionCompleted();

    useEffect(() => {
        startLoadRef.current = Date.now();
        CacheScheduleService.clear().then(() => console.log("Clear schedule local cache!"));
    }, []);

    useEffect(() => {
        if (customerId) {
            const localAddress = getLocalAddress(customerId);
            if (localAddress) {
                globalAddress = localAddress;
                putDraft(localAddress);
            }
        }
    }, [customerId])

    useEffect(() => {
        const hasCurrentBooking = getCurrentBooking(packageIndex);
        let canContinue = true;
        // Check if has current booking and has booking date then set booking date default
        if (hasCurrentBooking) {
            const bookingDate = hasCurrentBooking?.bookingDate;
            const bookingDateMoment = moment(bookingDate, Environment.dateFormat);
            if (bookingDateMoment.isValid()) {
                putDraft({bookingDate: bookingDateMoment.format(Environment.dateFormat)});
                bookingDateDefaultRef.current = bookingDateMoment.format(Environment.dateFormat);
                setFirstLoad(true);
                canContinue = false;
            }
        }
        // Check if has current booking and has schedule then set schedule default and booking date default from schedule
        if (canContinue) {
            getScheduleAvailable(campaignId, productServiceTemplateId, postalCode).then(({data, status}) => {
                setFirstLoad(true);
                if (status === 200 && data.data.startDate) {
                    const availableDate = moment(data.data.startDateFormat, Environment.dateFormat);
                    if (availableDate.isValid()) {
                        putDraft({
                            bookingDate: availableDate.format(Environment.dateFormat),
                        });
                        bookingDateDefaultRef.current = availableDate.format(Environment.dateFormat);
                    }
                }
            }).catch(reason => {
                setFirstLoad(true);
            });
        }


    }, [])

    useEffect(() => {
        if (firstLoad) {
            loadData().then();
        }
    }, [startMonth, endMonth, firstLoad]);

    useEffect(() => {
        if (Object.keys(globalBooking).length) {
            putDraft({startTime: "", endTime: "", ...globalBooking, ...globalAddress});
        } else {
            putDraft({
                startTime: "",
                endTime: "",
                schedule: null,
                bookingDate: bookingDateDefaultRef.current,
            })
        }
        onScrollPackage();
    }, [packageIndex]);

    const loadData = async () => {
        placeholderLoadingRef?.current?.show();
        console.log(`---------- Load data ${date.clone().format("MM/YYYY")} ----------`);
        const timeStart = Date.now();
        let cached = await CacheScheduleService.get(date, customerId);
        let result: any = cached || null;
        console.log("Cached:", !!cached);
        // Check on cache first
        if (!cached) {
            result = await listSchedule(campaignId, productServiceTemplateId, startMonth, endMonth);
            if (result?.status === 200) {
                CacheScheduleService.set(date, customerId, {
                    status: result.status,
                    data: result.data
                });
            }
            console.log("Api call:", `${Date.now() - timeStart}ms`);
        }

        // Call next month for preload
        const nextMonth = date.clone().add(1, 'months');
        const cachedNext = await CacheScheduleService.get(nextMonth, customerId);
        if (!cachedNext) {
            const resultCalenderMonthStartAndEnNext = getCalenderMonthStartAndEnd(nextMonth);
            listSchedule(campaignId, productServiceTemplateId, resultCalenderMonthStartAndEnNext.startMonth.format(format), resultCalenderMonthStartAndEnNext.endMonth.format(format)).then(res => {
                if (res?.status === 200) {
                    CacheScheduleService.set(nextMonth, customerId, {
                        status: res.status,
                        data: res.data
                    });
                }
                console.log("Api call next month:", `${Date.now() - timeStart}ms`);
            });
        }

        // Calc delay time for animation at least 400ms for better UX experience
        let timeFormat = Date.now();
        const delayTime = (startLoadRef.current + 400 > Date.now()) ? 400 : 0;
        const draftSchedules = await formatSchedulesAsync(result?.data?.data?.items || [], startMonth, endMonth, delayTime);
        setSchedules(draftSchedules);
        console.log("Format schedules:", `${Date.now() - timeFormat}ms`);

        placeholderLoadingRef?.current?.hide();
        setDelayLoading(false);

        console.log("Total time:", `${Date.now() - timeStart}ms`);
        console.log("----------  ----------");
    }

    const onNext = async () => {
        const values = {...draft};


        if (checkOutSlot(draft?.schedule, getAllBooking, packageIndex, schedules)) {
            message.error(T("Please select a timeslot!"))
            return;
        }

        if (!checkLimitDayBooking(campaign, values.bookingDate, values.startTime)) {
            message.error(T("Booking window is minimum {minDayToBook} days and maximum {maxDayToBook} days in advance.", {
                minDayToBook: campaign?.minDayToBook,
                maxDayToBook: campaign?.maxDayToBook
            }));
            return;
        }

        if (productServiceType === 'product') {
            if (!(values?.bookingDate && values?.startTime && values?.modeOfDelivery && values?.postalCode && values?.unitNo && values?.address)) {
                message.error(T("Please complete all fields!"));
                return;
            }
        }
        if (productServiceType === 'service') {
            if (isOnsiteMode && values?.postalCode?.length !== 6) {
                message.error(T("Postal Code invalid format!"));
                return;
            }
            const firstPostalCode = (values?.postalCode || "")?.toString().substring(0, 2);
            if (isOnsiteMode && draft?.schedule?.regions?.length > 0 && !draft?.schedule?.regions.find(item => item.postalCodes?.includes(firstPostalCode))) {
                message.error(T("Your region is not supported!"));
                return;
            }

            if (!(values?.bookingDate && values?.startTime)) {
                message.error(T("Please complete all fields!"));
                return;
            }
            if (isOnsiteMode && (!values?.startTime || !values?.postalCode || !values?.unitNo || !values?.address)) {
                message.error(T("Please complete all fields!"));
                return;
            }
        }

        // Update schedule when selected
        if (values?.schedule) {
            const scheduleId = values?.schedule?.scheduleId;
            const schedule = schedules.find(item => item.scheduleId === scheduleId);
            // Update schedule version to new value
            values.scheduleVersion = schedule?.scheduleVersion;
        }

        setCurrentBooking(values, packageIndex);

        if (isEndPackage) {
            // Navigate to next page
            navigate(`/${clientCode}/${campaignPath}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/question/${locationType}/0/${postalCode || ""}`);
        } else {
            goPackageIndex(packageIndex + 1)
        }
    }

    const goPackageIndex = (index) => {
        navigate(`/${clientCode}/${campaignPath}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/booking/${locationType}/${index}/${postalCode || ""}`);
    }

    const onSameLastPackage = () => {
        const lastValue = getCurrentBooking(packageIndex - 1);
        setDraft({...lastValue, notReset: true});
    }

    const onScrollPackage = () => {
        setTimeout(() => {
            document?.querySelector('.packages .active')?.scrollIntoView({
                behavior: "auto",
                block: "end",
                inline: "end"
            });
        }, 200);
    }


    const onChangeDevTz = () => {
        if (window.location.href.includes(".dev.") || window.location.href.includes("localhost")) {
            const localTimezone = getLocalTimezone();
            // Show input to input TZ for dev
            const value = window.prompt("Please input TZ for dev (Cancel to reset):", localTimezone.toString());
            if (value) {
                localStorage.setItem("DEV_TZ", value);
                window.location.reload();
            } else {
                localStorage.removeItem("DEV_TZ");
                window.location.reload();
            }
        }
    }

    const isEndPackage = ((packageIndex + 1) === quantity);
    const canSameLastPackage = (packageIndex !== 0 && packageIndex < quantity) && !draft.startTime;
    const isOnlineMode = locationType === 'online';
    const isOnsiteMode = locationType === 'onsite';
    const isMyLocationMode = locationType === 'my-location';

    return (<Container>
        <Header
            onDoubleClick={onChangeDevTz}
            title={T("Booking") + (devTz ? ` (TZ=${devTz})` : '')}
            back
            right={(<Step ignores={isOnlineMode ? [T("Location")] : []} current={isOnlineMode ? 1 : 2} dotStyle/>)}
        />

        <ContainerView>
            <PlaceholderLoadingContainer ref={placeholderLoadingRef}>
                {
                    quantity > 1 ? (
                        <Packages className={'packages'}>
                            {
                                [...Array(parseInt(quantity)).keys()].map((value, index) => {
                                    const hasValue = !!getCurrentBooking(index);
                                    const service = getLocalProductService(productServiceId);
                                    return (
                                        <PackageButton
                                            onClick={() => {
                                                if (hasValue) {
                                                    goPackageIndex(index);
                                                    onScrollPackage();
                                                }
                                            }}
                                            className={`${hasValue ? 'has-value' : ''} ${index.toString() === packageIndex.toString() ? 'active' : ""} package-${index}`}
                                            key={index.toString()}><span>{service?.name} ({value + 1})</span></PackageButton>
                                    )
                                })
                            }
                        </Packages>
                    ) : null
                }

                <Calendar value={draft.bookingDate} onChange={(value) => {
                    console.log("Selected date value:", value)
                    putDraft({
                        bookingDate: value,
                        schedule: null,
                        startTime: "",
                        endTime: "",
                    });
                }} schedules={schedules} isOnsite={isOnsiteMode} packageIndex={packageIndex}/>
                {
                    productServiceType === 'product' ? (
                        <Product draft={draft} putDraft={putDraft} postalCode={postalCode}></Product>
                    ) : (
                        <>
                            <Control>
                                <LabelView>{T('Available timeslot')}</LabelView>
                                <ChooseTime placeholder={T("Select a time")} packageIndex={packageIndex}
                                            value={draft?.startTime || undefined}
                                            onChange={value => {
                                                console.log("Selected time value:", value)
                                                if (!isOnsiteMode) {
                                                    putDraft({
                                                        schedule: value.schedule,
                                                        campaignScheduleId: value?.schedule?.sid,
                                                        scheduleId: value?.schedule?.scheduleId,
                                                        startTime: value.startTime,
                                                        endTime: value.endTime,
                                                        postalCode: value?.schedule?.postalCode,
                                                        unitNo: value?.schedule?.unitNo,
                                                        address: value?.schedule?.location,
                                                    })
                                                } else {
                                                    putDraft({
                                                        schedule: value.schedule,
                                                        campaignScheduleId: value?.schedule?.sid,
                                                        scheduleId: value?.schedule?.scheduleId,
                                                        startTime: value.startTime,
                                                        endTime: value.endTime,
                                                        ...globalAddress
                                                    })
                                                }
                                            }}
                                            isOnsite={isOnsiteMode}
                                            schedules={schedules} scheduleId={draft?.schedule?.sid}
                                            date={draft.bookingDate}/>
                            </Control>
                            {
                                draft?.schedule && isMyLocationMode ? (
                                    <Control>
                                        <LabelView style={{marginBottom: 3}}>{T('Our Venue')}</LabelView>
                                        <LabelViewSub className={'text'}>* Please arrive on time at our location on the
                                            selected appointment date.</LabelViewSub>
                                        <TextView>{draft?.schedule?.location || ""}</TextView>
                                        <TextView>{draft?.schedule?.unitNo || ""}</TextView>
                                        <TextView>{draft?.schedule?.postalCode || ""}</TextView>
                                    </Control>
                                ) : null
                            }

                            {
                                draft?.schedule && isOnsiteMode ? (
                                    <Control>
                                        <LabelView style={{marginBottom: 3}}>{T('Your Address')}</LabelView>
                                        <LabelViewSub className={'text'}>
                                            {T("* Please be on time at the address you have given us on your selected appointment date.")}
                                        </LabelViewSub>
                                        <TextView>{draft.address || ""}</TextView>
                                        <TextView>{draft.unitNo || ""}</TextView>
                                        <TextView>{draft.postalCode || ""}</TextView>
                                    </Control>
                                ) : null
                            }

                            <ControlRow
                                style={{display: "none"}}>
                                <Control>
                                    <LabelView2>{T('Postal Code')}</LabelView2>
                                    <InputView
                                        value={draft.postalCode}
                                        onChange={event => {
                                            const code = (event.target.value || "").substring(0, 6).replace(/\D/g, '');
                                            putDraft('postalCode', code)
                                        }}
                                        disabled={!!postalCode && isOnsiteMode && draft?.schedule?.regions?.length > 0}/>
                                </Control>
                                <div style={{width: 12}}/>
                                <Control>
                                    <LabelView2>{T('Unit No.')}</LabelView2>
                                    <InputView value={draft.unitNo}
                                               onChange={event => putDraft('unitNo', event.target.value)}/>
                                </Control>
                            </ControlRow>
                            <Control
                                style={{display: "none"}}>
                                <LabelView2 style={{marginBottom: 1}}>{T('Address')}</LabelView2>
                                <LabelViewSub>{T("* Please be on time at the address you have given us on your selected appointment date.")}</LabelViewSub>
                                <TextAreaView autoSize={{minRows: 3, maxRows: 12}} value={draft.address}
                                              onChange={event => putDraft('address', event.target.value)}/>
                            </Control>
                        </>

                    )
                }


                <ContainerViewFooter>
                    {canSameLastPackage ? (
                        <NextButton onClick={() => {
                            onSameLastPackage();
                        }}>{T('Same as the last package')}</NextButton>
                    ) : (
                        <NextButton onClick={() => {
                            onNext();
                        }}>{T('Next')}</NextButton>
                    )}
                </ContainerViewFooter>
            </PlaceholderLoadingContainer>
        </ContainerView>
        {
            !!delayLoading ? <BookingLoading/> : null
        }
        <AnonymousChatPopup fixed/>
    </Container>)
}
